import { render, staticRenderFns } from "./Vara.vue?vue&type=template&id=341c7d8c"
import script from "./Vara.vue?vue&type=script&lang=js"
export * from "./Vara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports